import { bootstrapApplication } from '@angular/platform-browser';
import '@angular/compiler';
import { appConfig } from './app/app.config';
import { App } from './app/app';
// main.ts
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import { environment } from './environment/environment';

// Force global locale
dayjs.locale('en'); 
// console.log('Dayjs locale is:', dayjs.locale());

// Remove all console.logs statmenets from the code
if(!environment.enableLogs) Object.keys(console).forEach(key => (console as any)[key] = () => {});
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
